import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";
import {getParam} from "../../components/Utils/Utils";

const selectNotificationsByUserId = async (pageable) => {
    try {
        return await needAuth.get(`/notifications?${getParam(pageable)}`);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const getNotificationsBySearch = async (search, pageable) => {
    try {
        return await needAuth.post(`/notifications?${getParam(pageable)}`, search);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const getNotificationConditions = async () => {
    try {
        return await needAuth.get(`/notifications/conditions`);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const countNotificationByUserId = async () => {
    try {
        return await needAuth.get(`/notifications/count`);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const releaseCountable = async () => {
    try {
        return await needAuth.put(`/notifications/countable/release`);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const releaseCheck = async (id) => {
    try {
        return await needAuth.put(`/notifications/${id}/check/release`);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const releaseAllCheck = async () => {
    try {
        return await needAuth.put(`/notifications/check/release`)
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

export {
    selectNotificationsByUserId,
    getNotificationsBySearch,
    countNotificationByUserId,
    releaseCountable,
    releaseCheck,
    releaseAllCheck,
    getNotificationConditions
}